import React from "react";
import { Box, Button, Divider, IconButton, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import backgroundImg from "assets/images/banner-background.png";
import { useModals } from "hooks";
import { useUserActions } from "store";

interface Props {}

export const Banner: React.FC<Props> = () => {
  const { openUpgradeAccount } = useModals();
  const { hideUnlockFullAccessBannerAction } = useUserActions();
  return (
    <Stack
      sx={{
        flexGrow: 1,
        bgcolor: "white",
        height: 138,
        minHeight: 138,
        maxHeight: 138,
        borderRadius: "8px",
        boxShadow: "sm",
        width: "100%",
        position: "relative"
      }}
    >
      <Stack sx={{ width: "fit-content", p: "21px 27px 17px 27px", zIndex: 2 }}>
        <Typography
          sx={{
            mb: "8.5px",
            leadingTrim: "both",
            textEdge: "cap",
            fontSize: "30px",
            lineHeight: "20px",
            fontWeight: 400,
            whiteSpace: "nowrap",
            color: "#0A3142",
            fontFamily: "Merriweather"
          }}
        >
          Unlock Full Access To Financial Peaks
        </Typography>
        <Divider sx={{ borderColor: "#82A1AF", mb: "6px" }} />
        <Typography
          sx={{
            fontSize: "17px",
            fontWeight: 400,
            lineHeight: 1,
            mb: "12px",
            color: "#0A3142",
            fontFamily: "Lato"
          }}
        >
          Upgrade your account to enjoy all features and capabilities
        </Typography>
        <Button onClick={openUpgradeAccount} sx={{ alignSelf: "flex-start" }} variant="contained">
          Upgrade
        </Button>
      </Stack>
      <IconButton
        onClick={hideUnlockFullAccessBannerAction}
        size="sm"
        sx={{ position: "absolute", top: 0, right: 0, zIndex: 2 }}
      >
        <CloseIcon />
      </IconButton>
      <Box
        sx={{
          bgcolor: "#26A6AE",
          width: 48,
          height: 48,
          opacity: "0.5",
          position: "absolute",
          zIndex: 2,
          right: "520px",
          top: "8px"
        }}
      />
      <Box
        sx={{
          background: `no-repeat right url(${backgroundImg})`,
          minHeight: 138,
          maxHeight: 138,
          position: "absolute",
          right: 0,
          top: 0,
          width: "100%",
          zIndex: 1
        }}
      />
    </Stack>
  );
};
